<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.generators')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div><el-button role="BUTTON_LEFT">LEFT</el-button>
                    <el-button role="BUTTON_RIGHT">RIGHT</el-button>
                    <el-button role="BUTTON_UP">UP</el-button>
                    <el-button role="BUTTON_DOWN">DOWN</el-button>
                    <el-button role="BUTTON_SELECT">SELECT</el-button>

                    <el-button role="BUTTON_START">START</el-button>
                    <el-button role="BUTTON_A">A</el-button>
                    <el-button role="BUTTON_B">B</el-button>

                    <el-button @click="loadfc">load</el-button>
                    <el-button @click="saves">saves</el-button>

                    <el-button @click="ssload">ssload</el-button>

                </div>
                <canvas id="nes-canvas" style="width: 100%"  width="512" height="480"/>

            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from './fhead.vue';

    var load;
    import jsnes from "jsnes";
    import fcc from "./fcc.js";


    export default {
        name: 'generators',
        components: {
            fhead
        },
        data() {
            return {
                fc: {
                    canvas: '',
                    canvas_ctx: '',
                    image: "",
                    framebuffer_u8: "",
                    framebuffer_u32: "",
                    SCREEN_WIDTH: 256,
                    SCREEN_HEIGHT: 240,
                    FRAMEBUFFER_SIZE: 0,
                    AUDIO_BUFFERING: 512,
                    SAMPLE_COUNT: 0,
                    SAMPLE_MASK: 0,
                    audio_samples_L: 0,
                    audio_samples_R: 0,
                    audio_write_cursor: 0,
                    audio_read_cursor: 0
                },
                nes: {}
            }
        },
        methods: {

            loadfc(){
                window.location.reload();

            },
            saves(){
                window.nesApp.save("123")
            },
            ssload(){
                window.nesApp.sload("123",fcc)
                // nesApp.load("https://apis.hebe.cc/public/shop/img/1/ml.nes");

            },

        },
        mounted: function () {
            const nesApp = fcc.createNes("nes-canvas");
            // @ts-ignore
            window.nesApp = nesApp;
            if (!nesApp) {
                console.log("NES 初始化失败！");
                alert("错误")
                return;
            }

            // nesApp.load("https://apis.hebe.cc/public/shop/img/1/ml.nes");
            nesApp.load("./static/1.nes");

            nesApp.bindButton2()

            // nesApp.bindButton("LEFT");
            // nesApp.bindButton("RIGHT");
            // nesApp.bindButton("UP");
            // nesApp.bindButton("DOWN");
            // nesApp.bindButton("SELECT");
            // nesApp.bindButton("START");
            // nesApp.bindButton("A");
            // nesApp.bindButton("B");


            // nes.buttonUp
        },
    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fc.vue